import { Component, ViewEncapsulation, inject } from '@angular/core';
import { AuthService } from '../../service/auth.service';
import {
  fadeInGlideDown,
  fadeInGlideUp,
} from '../../../shared/utils/animations';
import { ActionState } from '../../model/enums/auth-state.enum';
import { FormGroup } from '@angular/forms';
import { AuthMessageResponse } from '../../model/interfaces/auth-message-response.interface';
import { Router } from '@angular/router';
import { LocalStorageKeys } from '../../model/enums/local-storage.keys';

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
  standalone: false,
  animations: [fadeInGlideDown(), fadeInGlideUp()],
  encapsulation: ViewEncapsulation.None,
})
export class LogoutComponent {
  protected authService = inject(AuthService);
  private router = inject(Router);

  state: ActionState = ActionState.PENDING;
  form!: FormGroup;
  messages: AuthMessageResponse[] = [];

  iconsStyle = 'far';
  iconSize = 'fa-2xl';

  readonly icons = {
    checkCircle: 'fa-circle-check',
    actionRedo: 'fa-arrow-rotate-right',
  };

  onSubmit(event: Event): void {
    event.preventDefault();
    const projectName = localStorage.getItem(LocalStorageKeys.SELECTED_PROJECT_NAME) ?? '';
    this.router.navigate(['login', projectName]);
  }
}
